import * as Sentry from '@sentry/browser'
import React from 'react'
import { PageWrap } from 'shared/components/Base/Base'
import { Button } from 'shared/components/Button/Button'
import { TextV2 } from 'shared/components/Text/TextV2'
import { TYPOGRAPHY } from 'shared/theme/typographyV2'

import { RoadError } from '../../components/Icons/Icon'
import { isProduction } from '../../config/config'

interface MainErrorBoundaryProps {}

interface MainErrorBoundaryState {
  hasError: boolean
}

export class MainErrorBoundary extends React.Component<MainErrorBoundaryProps, MainErrorBoundaryState> {
  constructor(props: MainErrorBoundaryProps) {
    super(props)
    this.state = { hasError: false }
  }

  static getDerivedStateFromError() {
    return { hasError: true }
  }

  componentDidCatch(error: any, errorInfo: any) {
    console.error(error, errorInfo)
    if (isProduction) Sentry.captureException(error)
  }

  render() {
    if (this.state.hasError) {
      return (
        <PageWrap>
          <div className="text-center">
            <img src={RoadError} alt="" />
            <TextV2 type={TYPOGRAPHY.header1} className="mt-2 mb-4">
              Something went wrong
            </TextV2>
            <Button variant="text" onClick={() => window.location.reload()} margin="0 auto">
              Reload the page
            </Button>
          </div>
        </PageWrap>
      )
    }

    return this.props.children
  }
}
